export const ROLE_ACCESS_PRIORITY = [
  "ROLE_ADMIN",
  "ROLE_CLINIC",
  "ROLE_CLINICSUPERADMIN",
  "ROLE_CLINICADMIN",
  "ROLE_DOCTOR",
  "ROLE_GROOMER",
  "ROLE_RECEPTION",
  "ROLE_BILLING",
  "ROLE_INVENTORY",
  "ROLE_PHARMACY",
  "ROLE_RADIOLOGY",
];

/** Highest-priority role in the list. Roles outside the list come last. */
export const pickPrimaryRole = (roles = []) => {
  const list = (Array.isArray(roles) ? roles : []).filter(Boolean);
  if (list.length === 0) return "";

  const rank = new Map(
    ROLE_ACCESS_PRIORITY.map((role, index) => [role, index]),
  );
  const otherRank = ROLE_ACCESS_PRIORITY.length;

  return list.reduce((best, role) => {
    const bestRank = rank.has(best) ? rank.get(best) : otherRank;
    const roleRank = rank.has(role) ? rank.get(role) : otherRank;
    return roleRank < bestRank ? role : best;
  });
};
